import { useQuery } from '@tanstack/react-query';
import { getGroupList } from '../api/groupsApi';
import { Group } from '../api/groupsApi/interfaces';

export const useGetGroupList = (enabled: boolean = true) => {
  return useQuery<Group[]>({
    queryFn: () => getGroupList(),
    queryKey: ['group-list'],
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    enabled,
  });
};
